// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OU3X"};